import { Swords, X } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { clearPendingClubWarInvite, readPendingClubWarInvite } from '../../lib/pendingClubWarInvite'

export default function PendingClubWarInviteBanner() {
  const { user } = useAuth()
  const location = useLocation()
  const [token, setToken] = useState(() => readPendingClubWarInvite())

  useEffect(() => {
    const sync = () => setToken(readPendingClubWarInvite())
    window.addEventListener('argus:pending-club-war-invite', sync)
    window.addEventListener('storage', sync)
    return () => {
      window.removeEventListener('argus:pending-club-war-invite', sync)
      window.removeEventListener('storage', sync)
    }
  }, [])

  if (!user || !token || location.pathname === '/club-war/join') return null

  return (
    <div className="border-hd-orange/35 bg-hd-dark/95 text-hd-text-primary fixed inset-x-3 top-3 z-[80] mx-auto flex max-w-2xl items-center gap-3 rounded-2xl border p-3 shadow-2xl backdrop-blur-xl">
      <div className="bg-hd-orange/12 text-hd-orange flex h-10 w-10 shrink-0 items-center justify-center rounded-xl">
        <Swords className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-xs font-black">Club War invitation waiting</p>
        <p className="text-hd-text-muted mt-0.5 text-[10px]">
          Choose a team or club you manage to accept the challenge.
        </p>
      </div>
      <Link
        to={`/club-war/join?token=${encodeURIComponent(token)}`}
        className="bg-hd-orange text-hd-dark rounded-xl px-3 py-2 text-xs font-black"
      >
        Open
      </Link>
      <button
        type="button"
        onClick={() => {
          clearPendingClubWarInvite()
          setToken(null)
        }}
        className="text-hd-text-muted flex h-9 w-9 items-center justify-center rounded-lg"
        aria-label="Dismiss Club War invite"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  )
}
